import { Stack, Typography, Box, CircularProgress, Alert, Card } from '@mui/material'

import { getPackageDisplayName } from './utils/getPackageDisplayName'
import { formatCurrency } from './utils/formatCurrency'
import { StarterPackIcon, ProPackIcon, MegaPackIcon } from './utils/icons'

export function CreditPackagesSection({
  prices,
  selectedPackage,
  onPackageSelect,
  isLoading,
  purchaseError,
  purchaseSuccess,
}) {
  return (
    <Stack direction="column" gap="8px" minHeight={400} width="100%">
      <Typography color="#101828" fontSize={16} fontWeight={600} lineHeight="24px" variant="h6">
        Select Credit Package
      </Typography>

      {isLoading ? (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress />
        </Box>
      ) : (
        <Stack direction="column" gap="12px">
          {prices.map(price => (
            <CreditPackageCard
              key={price.id}
              isSelected={selectedPackage?.id === price.id}
              package={price}
              onClick={() => onPackageSelect(price)}
            />
          ))}
        </Stack>
      )}

      {purchaseError ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          {purchaseError}
        </Alert>
      ) : null}

      {purchaseSuccess ? (
        <Alert severity="success" sx={{ mt: 2 }}>
          Credits purchased successfully! Your account has been updated.
        </Alert>
      ) : null}
    </Stack>
  )
}

// Icon Components
const PricePackageIcons = {
  Small: <StarterPackIcon />,
  Medium: <ProPackIcon />,
  Large: <MegaPackIcon />,
}

// Credit Package Card Component
function CreditPackageCard({ package: pkg, isSelected, onClick }) {
  return (
    <Card
      sx={{
        padding: '16px !important',
        alignItems: 'flex-start',
        gap: '4px',
        flexDirection: 'row',
        borderRadius: '12px',
        cursor: 'pointer',
        border: isSelected ? 2 : 1,
        borderColor: isSelected ? 'primary.main' : 'divider',
        '&:hover': {
          borderColor: 'primary.main',
        },
      }}
      onClick={onClick}
    >
      <Stack direction="row" gap="12px">
        {PricePackageIcons[pkg.metadata?.package_type]}
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Stack>
            <Typography color="#344054" fontWeight={500} lineHeight="20px">
              {getPackageDisplayName(pkg)}
            </Typography>
            <Typography color="#475467" fontWeight={400} lineHeight="20px">
              Never expires
            </Typography>
          </Stack>
          <Typography color="#475467" fontWeight={400} lineHeight="20px">
            {formatCurrency(pkg.unit_amount)}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  )
}
